"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
const gatsby_1 = require("gatsby");
const SiteMap_1 = require("@components/organisms/SiteMap");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api")); // Component
var AccountHome = function AccountHome() {
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.signOut;
    }), user = _useGlobal[0], signOut = _useGlobal[1];
    var logout = function logout() {
        return _api_1.default('logout').then(function () {
            return signOut();
        });
    };
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname;
    if (!user)
        return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null);
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(SiteMap_1.NavColumn, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(SiteMap_1.MainList, null, /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Item, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/bookmarks",
        className: pathname.substr(1, 9) === 'bookmarks' ? 'active' : ''
    }, "Bookmarks")), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Item, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/account",
        className: pathname.substr(1, 7) === 'account' ? 'active' : ''
    }, "Account")), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Item, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/addresses",
        className: pathname.substr(1, 9) === 'addresses' ? 'active' : ''
    }, "Addresses")), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Item, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/wallet",
        className: pathname.substr(1, 6) === 'wallet' ? 'active' : ''
    }, "Wallet")), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Item, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/billing",
        className: pathname.substr(1, 7) === 'billing' ? 'active' : ''
    }, "Billing"))), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.MiscList, Object.assign({
        pathname: pathname
    }, {
        theme: "light"
    }))), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Column, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(SiteMap_1.RightHeadline, {
        theme: "light"
    }, "Welcome, ", user.firstName), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.AccountButtons, null, user && /*#__PURE__*/ react_1.default.createElement(SiteMap_1.StyledButton, {
        to: "/account",
        theme: "light"
    }, "View Profile"), user && /*#__PURE__*/ react_1.default.createElement(SiteMap_1.StyledButton, {
        onClick: function onClick() {
            return logout();
        },
        type: "outline",
        theme: "light"
    }, "Sign Out"))), /*#__PURE__*/ react_1.default.createElement(SiteMap_1.Column, {
        theme: "light"
    }, /*#__PURE__*/ react_1.default.createElement(SiteMap_1.SocialList, {
        theme: "light"
    })));
};
exports.default = AccountHome;
